export const getters = {
    getNfe: state => state.nfe,
    getNfce: state => state.nfce,
    getNfes: state => state.nfes,
    getModalGerarNfe: state => state.modalGerarNfe,
    getModalGerarNfce: state => state.modalGerarNfce,
    getModalCancelarNfe: state => state.modalCancelarNfe,
    getModalCancelarNfce: state => state.modalCancelarNfce,
    getTiposFreteNfe: state => state.tiposFreteNfe,
    getTiposOperacaoNfe: state => state.tiposOperacaoNfe,
    getModalEnviarNfeEmail: state => state.modalEnviarNfeEmail,
    getModalEstornoNfe: state => state.modalEstornoNfe,
    getModalCartaCorrecaoNfe: state => state.modalCartaCorrecaoNfe,
}

export default {}